import { useState } from 'react';

import StyledWidgetAccordion from './__styled__/StyledWidgetAccordion';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  items: React.ReactNode[];
  defaultExpanded?: boolean;
}

export default function WidgetAccordion({ items, children, defaultExpanded = false }: Props) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  return (
    <>
      <StyledWidgetAccordion $expanded={expanded}>
        <div onClick={() => setExpanded((prev) => !prev)} className="accord-heading">
          {children}
        </div>
        <div className="accord-items">
          <div>{items}</div>
        </div>
      </StyledWidgetAccordion>
    </>
  );
}
